import { render, staticRenderFns } from "./SbbBinMarker.vue?vue&type=template&id=f91e11ea&"
import script from "./SbbBinMarker.vue?vue&type=script&lang=js&"
export * from "./SbbBinMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports